/**
 * The gut line before the draw (journal practice 2026-10-28, DESIGN §1;
 * contract API.md §1). On the interview's ready turn the Mystic asks one
 * optional line (socket reference `gut-ask`); whatever the seeker types next
 * is their gut line. While the ask is open the composer reads the server's
 * placeholder. Select cards stays offered as it is.
 */
export const GUT_PLACEHOLDER = 'My gut says…'

/** The ask is the Mystic's latest line and the seeker hasn't answered it yet. */
export function gutAskOpen (messages) {
  const ms = Array.isArray(messages) ? messages : []
  for (let i = ms.length - 1; i >= 0; i--) {
    const m = ms[i]
    if (!m) continue
    if (m.type === 'user') return false
    if (m._ref === 'gut-ask') return true
    // Buttons painted under the ask (Select cards) are not a new line.
    if (!String(m.text || '').trim()) continue
    return false
  }
  return false
}

/**
 * Whether a conversation turn came back with the picker to open: a turn
 * the seeker typed (their gut line, API.md §1) that the server answered by
 * leaving the interview for SELECTING_CARDS. The app armed the picker only
 * on a Select cards tap, so "Hold that. Now choose your four." ended on the
 * reply box (prod v0.30.0, 2026-10-29). A tap arms the picker itself, a care
 * reply stays in the interview, and a picker already up is never re-armed.
 */
export function turnOpensPicker ({ actionType, before, after } = {}) {
  return actionType === 'continue_conversation' && after === 'SELECTING_CARDS' && before !== 'SELECTING_CARDS'
}
